// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3eELM","label":"Labeled_label__TvmWZ","divider":"Labeled_divider__2BSO1"};